import { createAction } from 'redux-act';

import Employee from '../../../../models/interfaces/Employee';
import FetchPayload from '../../FetchPayload';
import CompanyPayload from './CompanyPayload';

export interface FetchEmployeesPayload extends FetchPayload, CompanyPayload {}
export const fetchEmployees = createAction<FetchEmployeesPayload>('FETCH_EMPLOYEES');

export interface EmployeesFetchedPayload extends CompanyPayload {
  employees: Employee[];
}
export const employeesFetched = createAction<EmployeesFetchedPayload>('EMPLOYEES_FETCHED');

export const employeesFetchFailed = createAction<CompanyPayload>('EMPLOYEES_FETCH_FAILED');

export type EmployeeFetchResponsePayload = EmployeesFetchedPayload | CompanyPayload;
